import type { ShoppingCartContextProps } from 'src/app/shared/hooks/useShoppingCart';
import {
  getProductFeatureByType,
  type FeatureType,
  type FeatureTypeToTypescriptTypeMap,
} from 'src/app/utils/getProductFeatureByType';
import type { AppState } from 'src/types/appState';

export const getProductFeatureForPreview = <T extends FeatureType>({
  featureType,
  productFeaturesFromCart,
  productFeaturesFromPostedJob,
}: {
  featureType: T;
  productFeaturesFromCart?: ShoppingCartContextProps['cartFeatures'];
  productFeaturesFromPostedJob: AppState['session']['productFeatures'];
}): FeatureTypeToTypescriptTypeMap[T] | undefined =>
  getProductFeatureByType({
    featureType,
    productFeatures: productFeaturesFromCart,
  }) ||
  getProductFeatureByType({
    featureType,
    productFeatures: productFeaturesFromPostedJob,
  });
